<template>
  <div class="col-md-12" v-bind:class="{ 'mt-5': hasEvents }">
    <div class="container-fluid  pt-0 pb-1">
      <div class="row mobile-view ">
        <div class="col-md-12">
          <div class="row sort-menu" v-if="hasEvents">
            <div class="col-auto p-0">
              <selector id="type-sel" name="type-sel" mandatory="false" :data="types" valuefield="type_id" textfield="type_name" inlinerows="false" classes="bg-gray" blockClasses="" blockLabelClass="px-0" ref="typeSelector" v-model="selectedType" @change="filterEvents"></selector>
            </div>
            <div class="col-auto p-0 pt-2 d-none d-sm-block">
              <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
            </div>
            <!-- <div class="col text-center">
              <my-button :label="$t(LangConstants.date_table_header)" spanVerticalAllign="" variant="sort-badge" classes="m-1 mx-2" type="button" fa="sort" fapos="right" @onClick="sortByStartDate()"></my-button>
              <my-button :label="$t(LangConstants.location_table_header)" spanVerticalAllign="" variant="sort-badge" classes="m-1 mx-2" type="button" fa="sort" fapos="right" @onClick="sortByLocation()"></my-button>
              <my-button :label="$t(LangConstants.available_slots_table_header)" spanVerticalAllign="" variant="sort-badge" classes="m-1 mx-2" type="button" fa="sort" fapos="right" @onClick="sortByAvailableSlots()"></my-button>
              <my-button :label="$t(LangConstants.last_day_for_reg_table_header)" spanVerticalAllign="" variant="sort-badge" classes="m-1 mx-2" type="button" fa="sort" fapos="right" @onClick="sortByLastDateOfReg()"></my-button>
            </div> -->
          </div>

          <div class="row d-flex align-items-center mt-2 mb-2 form-base list-items-container pt-2 pb-2" v-for="event in events_" :key="event.id">
            <div class="col-md-2 list-item">
              <div>
                <b>{{ $t(LangConstants.on) }} : </b>
              </div>
              {{ dayjs(formatEpochDate(event.start_date)).format("DD MMMM") /*  + " - " + dayjs(formatEpochDate(event.end_date)).format("DD MMM") */ }}
            </div>
            <div class="col-md-2 list-item">
              <div>
                <b>{{ $t(LangConstants.at) }} : </b>
              </div>
              {{ event.location }}
            </div>
            <div class="col-md-2 list-item">
              <div>
                <b>{{ $t(LangConstants.available) }} : </b>
              </div>
              {{ (event.booked_slots ? event.booked_slots : 0) + " " + LangConstants.out_of_text + " " + event.max_attendance_count }}
            </div>
            <div class="col-md-3 list-item">
              <div>
                <b>{{ $t(LangConstants.ends_on) }} : </b>
              </div>
              {{ dayjs(formatEpochDate(event.last_registration_date)).format("DD MMMM") }}
            </div>
            <div class="col-xs-3 col-sm-2 col-md-1 col-lg-1 pl-0 pr-0 list-item">
              <my-input id="slots" name="my-name" inlinerows="false" inlinerowclasses="" inlineLabelClass="" inlineInputClass="" classes="bg-gray" type="number" :label="''" :maxLength="event.booked_slots" v-model="slotQuantities[event.id]" v-if="event.booked_slots > 0" ref="quantity"></my-input>
            </div>
            <div class="col-md-2 list-item">

              <template v-if="!loginUrl">
                <my-button spanVerticalAllign="" :label="event.booked_slots > 0 ? $t(LangConstants.register_cta_button) : $t(LangConstants.sold_out_button)" variant="solid-primary" classes="course-buy-btn" @onClick="event.booked_slots > 0 ? buyCourse(event.id) : ''" :isDisabled="event.booked_slots > 0 ? false : true" v-if="isPreview == false"></my-button>
                <my-button spanVerticalAllign="" :label="$t(LangConstants.register_cta_button)" variant="solid-primary" classes="course-buy-btn" :isDisabled="true" v-if="isPreview == true"></my-button>
              </template>
              <my-button  v-if="loginUrl" :label="$t(LangConstants.login_to_view_pricing)" variant="solid-primary" classes="course-buy-btn" fa="" :link="loginUrl" target="_top"></my-button>
            
            </div>
          </div>
        </div>
      </div>

      <no-data-box v-if="events.length == 0">
        <h5>
          {{ $t(LangConstants.no_events_message) }}
        </h5>
        <div class="row mt-4">
          <div class="col-md-2 mx-auto">
            <my-button :label="$t(LangConstants.contact_us_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="button" @onClick="showContactFormModal()"></my-button>
          </div>
        </div>
      </no-data-box>

      <b-modal id="contact-us-modal" :title="$t(LangConstants.contact_us_button_label)" hide-footer>
        <b-form ref="contactUsForm" @submit.stop.prevent="handleContactUs">
          <div class="row">
            <div class="col-6">
              <my-input id="first-name" name="first-name" :label="$t(LangConstants.first_name_input_label)" mandatory="true" placeholder="" inlinerows="false" v-model="contactUsForm.template_parameters.firstname" type="text"></my-input>
            </div>
            <div class="col-6">
              <my-input id="last-name" name="last-name" :label="$t(LangConstants.last_name_input_label)" mandatory="true" placeholder="" inlinerows="false" v-model="contactUsForm.template_parameters.lastname" type="text"></my-input>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <my-input id="email" name="email" :label="$t(LangConstants.contact_us_form_email_input_label)" mandatory="true" placeholder="" inlinerows="false" v-model="contactUsForm.template_parameters.email" type="email"></my-input>
            </div>
            <div class="col-6">
              <my-input id="telephone" name="telephone" :label="$t(LangConstants.contact_us_form_telephone_input_label)" mandatory="true" placeholder="" inlinerows="false" v-model="contactUsForm.template_parameters.telefon" type="text"></my-input>
            </div>
            <div class="col-md-6">
              <my-input id="contact-company-name" name="contact-company-name" :label="$t(LangConstants.contact_us_contact_company_name_input_label)" mandatory="true" placeholder="" inlinerows="false" v-model="contactUsForm.template_parameters.contact_company_name" type="text"></my-input>
            </div>
            <div class="col-md-6">
              <my-input id="contact-company-address" name="contact-company-address" :label="$t(LangConstants.contact_us_contact_company_address_input_label)" mandatory="true" placeholder="" inlinerows="false" v-model="contactUsForm.template_parameters.contact_company_address" type="text"></my-input>

              <!-- <my-button
                    :label=" (event.booked_slots > 0 )? $t(LangConstants.register_cta_button) : $t(LangConstants.sold_out_button)"
                    variant="solid-primary"
                    classes="course-buy-btn btn-block"
                    @onClick="event.booked_slots > 0 ? buyCourse(event.id) : ''"
                    :isDisabled="event.booked_slots > 0 ? false : true"
                    v-if="isPreview == 'false'"
                ></my-button> -->
              <!-- <my-button
                    :label="$t(LangConstants.register_cta_button)"
                    variant="solid-primary"
                    classes="course-buy-btn btn-block"
                    :isDisabled="true"
                    v-if="isPreview == 'true'"
                ></my-button> -->
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <my-text-area id="message" name="message" mandatory="true" :label="$t(LangConstants.contact_us_message_input_label)" inlinerows="false" v-model="contactUsForm.template_parameters.message"></my-text-area>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <my-button :label="$t(LangConstants.submit_button_label)" variant="solid-primary" classes="mt-4 mb-4" height="56px" width="100%" type="submit" :isDisabled="isPreview == true ? true : false"></my-button>
            </div>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/course-events.scss";
import MyButton from "../atoms/Button.vue";
import MyInput from "../atoms/Input.vue";
import MyTextArea from "../atoms/TextArea.vue";
import NoDataBox from "../atoms/NoDataBox.vue";
import Constants from "../../constants/index";
import Helper from "../../functions/index";
import Selector from "../atoms/Selector.vue";

const dayjs = require("dayjs");

export default {
  name: "course-events",

  props: {
    signInLink: {
      default: "",
    },
    events: {
      required: true,
    },
    course: {
      required: true,
    },
    isPreview: {
      default: false,
    },
  },

  mounted() {
    this.sortByStartDate();
    for (let i = 0; i < this.events.length; i++) {
      this.$refs.quantity[i].text = 1;
    }

    console.log(this.events);
  },
  created() {
    this.events__ = this.events;
  },

  data: function() {
    return {
      selectedType: 0,
      events__: [],
      sortedByLocation: false,
      sortedByStartDate: false,
      sortedByAvailableSlots: false,
      sortedByLastDateOfReg: false,
      slotQuantities: {},
      contactUsForm: {
        to_address: "recipient@example.com",
        template_id: "27718774",
        instance_id: this.course.instance_id,
        template_parameters: {
          product_url: "https://sparkfore.com/",
          product_name: "Sparkfore",
          course_name: this.course.courseInstance.name,
          firstname: "",
          lastname: "",
          email: "",
          telefon: "",
          contact_company_name: "",
          contact_company_address: "",
          message: "",
          company_name: "Sparkfore",
          company_address: "Vibyholmsvägen 25, 261 92 Härslöv, Sweden",
        },
      },
    };
  },

  computed: {
    loginUrl(){
      if (this.$props.signInLink) {
        return this.$props.signInLink;
      } else {
        return false;
      }
    },
    types() {
      return [
        { type_id: "event_date_asc", type_name: this.LangConstants.date_table_header + " (" + this.LangConstants.asc + ")" },
        { type_id: "event_date_desc", type_name: this.LangConstants.date_table_header + " (" + this.LangConstants.desc + ")" },
        { type_id: "location_asc", type_name: this.LangConstants.location_table_header + " (" + this.LangConstants.asc + ")" },
        { type_id: "location_desc", type_name: this.LangConstants.location_table_header + " (" + this.LangConstants.desc + ")" },
        { type_id: "available_seats_asc", type_name: this.LangConstants.available_slots_table_header + " (" + this.LangConstants.asc + ")" },
        { type_id: "available_seats_desc", type_name: this.LangConstants.available_slots_table_header + " (" + this.LangConstants.desc + ")" },
        { type_id: "last_reg_date_asc", type_name: this.LangConstants.last_day_for_reg_table_header + " (" + this.LangConstants.asc + ")" },
        { type_id: "last_reg_date_desc", type_name: this.LangConstants.last_day_for_reg_table_header + " (" + this.LangConstants.desc + ")" },
      ];
    },
    cities() {
      const eventLocations = [...new Set(this.events.map((event) => event.location))];

      return eventLocations.map(function(location) {
        return { city_name: location };
      });
    },

    months() {
      const eventStartMonths = [...new Set(this.events.map((event) => dayjs(event.start_date).format("MMMM")))];
      return eventStartMonths.map(function(month) {
        return { month_id: month, month_name: month };
      });
    },

    LangConstants() {
      return Constants;
    },

    dayjs() {
      return dayjs;
    },

    hasEvents() {
      return this.events__.length != 0;
    },
    events_() {
      return this.events__;
    },
  },

  methods: {
    filterEvents() {
      switch (this.selectedType) {
        case "event_date_asc":
          this.sortByStartDateFlag(true);
          break;
        case "event_date_desc":
          this.sortByStartDateFlag(false);
          break;
        case "location_asc":
          this.sortByLocationFlag(true);
          break;
        case "location_desc":
          this.sortByLocationFlag(false);
          break;
        case "available_seats_asc":
          this.sortByAvailableSlotsFlag(true);
          break;
        case "available_seats_desc":
          this.sortByAvailableSlotsFlag(false);
          break;
        case "last_reg_date_asc":
          this.sortByLastDateOfRegFlag(true);
          break;
        case "last_reg_date_desc":
          this.sortByLastDateOfRegFlag(false);
          break;
      }
    },
    formatEpochDate(date) {
      return Helper.epochToJsDate(date);
    },
    buyCourse(eventId) {
      let quantity = this.slotQuantities[eventId];
      const event = this.events.find((event) => event.id == eventId);

      if (!quantity || quantity == 0) {
        quantity = 1;
      }

      if (quantity && quantity > 0 && quantity <= event.booked_slots) {
        const session_id = this.$route.query.session_key ? this.$route.query.session_key : 0;
        window.parent.location = this.$store.getters.instanceUrl + "v/company-account/webshop/" + this.$props.course.courseid + "/" + this.$props.course.instance_id + "/" + session_id + "?event_id=" + eventId + "&quantity=" + quantity + "&participant_view=true";
      } else {
        this.$fire({
          title: this.LangConstants.no_quantity_warning_title,
          text: this.LangConstants.no_quantity_warning_text,
          type: "warning",
        });
      }
    },

    sortByLocation() {
      let newEventsList = [];
      if (this.sortedByLocation == true) {
        console.log("true");
        // newEventsList = this.events.sort((a, b) => (a.location > b.location ? -1 : 1));
        newEventsList = this.events__.sort((a, b) => (a.location > b.location ? -1 : 1));
      } else {
        console.log("false");
        // newEventsList = this.events.sort((a, b) => (a.location > b.location ? 1 : -1));
        newEventsList = this.events__.sort((a, b) => (a.location > b.location ? 1 : -1));
      }
      // this.events = [];
      // this.events = newEventsList;
      this.events__ = [];
      this.events__ = newEventsList;

      this.sortedByLocation = this.sortedByLocation == true ? false : true;
    },
    sortByLocationFlag(isAsc) {
      let newEventsList = [];
      if (isAsc == true) {
        newEventsList = this.events__.sort((a, b) => (a.location > b.location ? 1 : -1));
      } else {
        newEventsList = this.events__.sort((a, b) => (a.location > b.location ? -1 : 1));
      }
      this.events__ = [];
      this.events__ = newEventsList;
    },

    sortByStartDate() {
      let newEventsList = [];
      if (this.sortedByStartDate == true) {
        // newEventsList = this.events.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        newEventsList = this.events__.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
      } else {
        // newEventsList = this.events.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        newEventsList = this.events__.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      }
      // this.events = [];
      // this.events = newEventsList;
      this.events__ = [];
      this.events__ = newEventsList;

      this.sortedByStartDate = this.sortedByStartDate == true ? false : true;
    },
    sortByStartDateFlag(isAsc) {
      let newEventsList = [];
      if (isAsc == true) {
        newEventsList = this.events__.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      } else {
        newEventsList = this.events__.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
      }
      this.events__ = [];
      this.events__ = newEventsList;
    },
    sortByAvailableSlots() {
      let newEventsList = [];
      if (this.sortedByAvailableSlots == true) {
        // newEventsList = this.events.sort((a, b) => (a.booked_slots > b.booked_slots ? -1 : 1));
        newEventsList = this.events__.sort((a, b) => (a.booked_slots > b.booked_slots ? -1 : 1));
      } else {
        // newEventsList = this.events.sort((a, b) => (a.booked_slots > b.booked_slots ? 1 : -1));
        newEventsList = this.events__.sort((a, b) => (a.booked_slots > b.booked_slots ? 1 : -1));
      }
      // this.events = [];
      // this.events = newEventsList;
      this.events__ = [];
      this.events__ = newEventsList;

      this.sortedByAvailableSlots = this.sortedByAvailableSlots == true ? false : true;
    },
    sortByAvailableSlotsFlag(isAsc) {
      let newEventsList = [];
      if (isAsc) {
        newEventsList = this.events__.sort((a, b) => ( ( a.max_attendance_count - a.booked_slots ) > ( b.max_attendance_count - b.booked_slots ) ? -1 : 1));
      } else {
        newEventsList = this.events__.sort((a, b) => ( ( a.max_attendance_count - a.booked_slots ) > (b.max_attendance_count - b.booked_slots) ? 1 : -1));
      }
      this.events__ = [];
      this.events__ = newEventsList;
    },
    sortByLastDateOfReg() {
      let newEventsList = [];
      if (this.sortedByLastDateOfReg == true) {
        // newEventsList = this.events.sort((a, b) => new Date(b.last_registration_date) - new Date(a.last_registration_date));
        newEventsList = this.events__.sort((a, b) => new Date(b.last_registration_date) - new Date(a.last_registration_date));
      } else {
        // newEventsList = this.events.sort((a, b) => new Date(a.last_registration_date) - new Date(b.last_registration_date));
        newEventsList = this.events__.sort((a, b) => new Date(a.last_registration_date) - new Date(b.last_registration_date));
      }
      // this.events = [];
      // this.events = newEventsList;
      this.events__ = [];
      this.events__ = newEventsList;

      this.sortedByLastDateOfReg = this.sortedByLastDateOfReg == true ? false : true;
    },
    sortByLastDateOfRegFlag(isAsc) {
      let newEventsList = [];
      if (isAsc == true) {
        newEventsList = this.events__.sort((a, b) => new Date(a.last_registration_date) - new Date(b.last_registration_date));
      } else {
        newEventsList = this.events__.sort((a, b) => new Date(b.last_registration_date) - new Date(a.last_registration_date));
      }
      this.events__ = [];
      this.events__ = newEventsList;
    },

    showContactFormModal() {
      this.$bvModal.show("contact-us-modal");
    },

    handleContactUs() {
      this.$bvModal.hide("contact-us-modal");
      this.$store.dispatch("createCoursesEventInquiry", this.contactUsForm).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: this.$t(this.LangConstants.contact_us_form_submit_success_message),
            type: "success",
            timer: 6000,
          });
        }
      });
    },

    filterBy() {
      if (this.selectedCity == 0 && this.selectedMonth == 0) {
        this.filteredEvents = this.events__;
      } else if (this.selectedCity == 0 && this.selectedMonth != 0) {
        this.filteredEvents = this.events__.filter((event) => dayjs(event.start_date).format("MMMM") == this.selectedMonth);
      } else if (this.selectedCity != 0 && this.selectedMonth == 0) {
        this.filteredEvents = this.events__.filter((event) => event.location == this.selectedCity);
      } else {
        this.filteredEvents = this.events__.filter((event) => event.location == this.selectedCity && dayjs(event.start_date).format("MMMM") == this.selectedMonth);
      }
    },
  },

  components: {
    Selector,
    MyButton,
    MyInput,
    MyTextArea,
    NoDataBox,
  },
};
</script>
